import { Component, OnInit, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PatientService } from '../../services/patients/patient.service';
import { ReportService } from '../../services/reports/report.service';
import { ProviderService } from '../../services/providers/provider.service';
import * as moment from 'moment';
import { Patient } from '../../classes/patient';



@Component({
  moduleId: module.id,
  selector: 'my-last-patients',
  templateUrl: 'last-patients.component.html',
  styleUrls: ['../../patients/patients.component.css']
})

export class LastPatientsComponent implements OnInit, OnChanges {

  selectedUser: any;
  protected createCalled: boolean = false;
  protected deleteCalled: boolean = false;

  patients: any[];
  loading: boolean = true;

  @Input() providers: any[] = []
  provider: any = {
  }


  from: string
  to: string

  title: string = "Created patients in a time lapse"

  fromDate: Date
  toDate: Date

  //ACA EMPPIEZO CON LA TABLA
  patientsToShow: any[] = [];
  pages: number;
  patientsPerPage = 10;
  patientsPerGet = 1000;
  currentPage = 0;
  pagesArray: any[] = [];
  timesSkipped = 0;
  havepatients = true;
  //ACA TERMINO CON LA TABLA



  constructor(
    protected router: Router,
    protected patientService: PatientService,
    protected infoService: ReportService,
    protected providerService: ProviderService) { }

  protected getpatientstring(): string {

    return 'patient';
  };

  protected getpatientsString(): string {

    return 'Patients';
  };

  /**
   * @param patients 
   */
  createdAt(patients: any[]) {
    for (let i = 0; i < patients.length; i++) {
      patients[i].createdAt = moment(patients[i].createdAt).format('DD/MM/YYYY')
    }
  }


  onSelect(user: any): void {
    this.selectedUser = user;
    this.router.navigate([this.getDetailUrl()]);
  }

  protected getDetailUrl(): string {
    return '/patient/' + this.selectedUser.id;
  };

  ngOnInit(): void {
    //this.getProviders()
    this.prepareDate()
    // this.loadInfo(false)
    //this.getpatients()
  }

  ngOnChanges(changes:SimpleChanges){
    if (changes["providers"].currentValue!=undefined) {
      this.loading = false
      this.provider = { id: 0, name: "All" }
    }
  }

  getProviders() {
    this.providerService.get().then((providers) => {
      this.providers = providers
      this.loading = false
      this.providers.push({ id: 0, name: "All" })
      this.provider = { id: 0, name: "All" }
    })

  }

  selectProvider(provider) {
    this.provider = provider
    this.prepareDate()
  }

  prepareDate() {
    let now = moment()
    let dow = now.format('E')
    let monday = now.subtract('days', Number(dow) - 1)
    this.from = monday.format('DD-MM-YYYY')
    this.to = moment().format('DD-MM-YYYY')
    // this.loadInfo()
  }

  loadInfo(useProvider: boolean) {
    //this.patientservice.get({ from: this.from, to: this.to, loggedIn: true, limit: this.patientsPerGet })
    let options = {
      from:this.from,
      to:this.to
    }
    if (useProvider) options["provider"] = this.provider.id

    this.patientService.count(options)
      .then(response => {
        //this.patients = patients
        //this.createdAt(this.patients);
        //this.buildTable();
        //this.configPages()
        this.loading = false;
        this.timesSkipped++
        console.log(response)
        this.title = response.count + ' patients created'
      })
  }

  configPages(): void {
    this.pages = ((this.patients.length / this.patientsPerPage) >> 0); //Para que me quede un numero entero
    if ((this.pages * this.patientsPerPage) < this.patients.length) {
      this.pages++;
    }
    this.patientsToShow = this.patients.slice(this.currentPage, this.patientsPerPage);
    this.pagesArray = [] //have to restart it
    for (let i = 0; i < this.pages; i++) {
      this.pagesArray.push({ n: i });
    }
  }

  setPage(page: number) {
    this.currentPage = page;
    this.changePage();
  }
  backPage() {
    if (this.currentPage == 0) {
      return;
    }
    this.currentPage--;
    this.changePage();
  }
  nextPage() {
    if (this.currentPage >= (this.pages - 1)) {
      /*if (this.havepatients) {
          this.needMorepatients({ skip: this.patientsPerGet * this.timesSkipped, limit: this.patientsPerGet, from: this.from, to: this.to });
      }
      else*/
      return;
    }
    this.currentPage++;
    this.changePage();
  }

  changePage(): void {
    let inicio = this.currentPage * this.patientsPerPage;
    this.patientsToShow = this.patients.slice(inicio, inicio + this.patientsPerPage)
  }
  /*
  needMorepatients(params) {
      this.timesSkipped++;
      let i = 0;
      this.patientservice.get(params)
          .then(patients => {
              if (0 < patients.length) {
                  this.createdAt(patients)
                  for (i; i < patients.length; i++) {
                      this.patients.push(patients[i])
                  }
  
                  this.havepatients = patients.length === this.patientsPerGet
                  this.configPages();
                  this.buildTable()
              }
          })
  }*/

  /*morePages() {
      if (this.havepatients) {
          let params = { skip: this.patientsPerGet * this.timesSkipped, limit: this.patientsPerGet, from: this.from, to: this.to }
          this.needMorepatients(params);
      }
  }*/


  filter() {
    this.loading = true;
    if (this.fromDate) this.from = moment(this.fromDate,'YYYY-MM-DD').format('DD-MM-YYYY')//this.getDate(this.fromDate)
    if (this.toDate) this.to = moment(this.toDate,'YYYY-MM-DD').format('DD-MM-YYYY')
    this.timesSkipped = 0;
    let useProvider = this.provider.id != 0
    this.loadInfo(useProvider)
  }

  /* 
  DE ACA EN ADELANTE TODO LO QUE ES EL CHART
  */

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };

  public barChartLabels: string[];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
  public days: any[] = []
  public data: any[] = [0, 0, 0, 0, 0, 0, 0, 0]
  public chart: boolean = false;

  public barChartData: any[] = [
    //{ data: this.data, label: 'Patients' }
  ];


  buildTable() {
    this.barChartData = []
    this.days = []
    let from = this.from
    let to = this.to
    while (from != to) {
      this.days.push(from)
      from = moment(from, "DD-MM-YYYY").add("1", "day").format('DD-MM-YYYY')
    }
    this.days.push(this.to)
    this.barChartLabels = this.days
    this.data = this.days.map((day) => {
      return 0;
    })

    let created
    for (let i = 0; i < this.patients.length; i++) {
      created = moment(this.patients[i].createdAt, "DD/MM/YYYY").format("DD-MM-YYYY")//.slice(0, 5)
      for (let j = 0; j < this.days.length; j++) {
        if (this.days[j] == created) this.data[j]++
      }
    }
    this.barChartData.push({ data: this.data, label: "Patients" })
    this.chart = true
  }

  public chartClicked(e: any): void {
    //console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }

  /*TERMINA EL CHART */

}



// WEBPACK FOOTER //
// ./src/app/patients/lastPatients/last-patients.component.ts